import { useNavigate, useRouter } from '@tanstack/react-router';
import { useCallback } from 'react';

export type NavigateBackFallback = Parameters<ReturnType<typeof useNavigate>>[0];

/**
 * ブラウザの「戻る」に近い挙動。
 * アプリ内履歴があれば `history.back()`、なければ `fallback` で遷移します。
 */
export function useNavigateBack(): (fallback: NavigateBackFallback) => void {
  const router = useRouter();
  const navigate = useNavigate();

  return useCallback(
    (fallback: NavigateBackFallback) => {
      if (router.history.canGoBack()) {
        router.history.back();
        return;
      }
      void navigate(fallback);
    },
    [router, navigate],
  );
}
